/* House of Rings — theme behaviour */
document.addEventListener('DOMContentLoaded', function () {
  /* ---- hero slider ---- */
  document.querySelectorAll('[data-hor-slider]').forEach(function (root) {
    var track = root.querySelector('.hor-hero__track');
    var slides = root.querySelectorAll('.hor-hero__slide');
    var dots = root.querySelectorAll('.hor-hero__dots button');
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function auto() { clearInterval(timer); if (slides.length > 1) timer = setInterval(function () { go(i + 1); }, 6000); }
    root.querySelectorAll('[data-hor-prev]').forEach(function (b) { b.addEventListener('click', function () { go(i - 1); auto(); }); });
    root.querySelectorAll('[data-hor-next]').forEach(function (b) { b.addEventListener('click', function () { go(i + 1); auto(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); auto(); }); });
    go(0); auto();
  });

  /* ---- horizontal rails: arrows ---- */
  document.querySelectorAll('[data-hor-rail-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var rail = document.querySelector(btn.getAttribute('data-hor-rail-next'));
      if (rail) rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' });
    });
  });
  document.querySelectorAll('[data-hor-rail-prev]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var rail = document.querySelector(btn.getAttribute('data-hor-rail-prev'));
      if (rail) rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' });
    });
  });

  /* ---- horizontal rails: page dots ---- */
  document.querySelectorAll('[data-hor-carousel]').forEach(function (wrap) {
    var rail = wrap.querySelector('[data-hor-rail]');
    var dotBox = wrap.querySelector('[data-hor-rail-dots]');
    if (!rail || !dotBox) return;

    var pages = 0;
    function pageCount() {
      return Math.max(1, Math.ceil(rail.scrollWidth / rail.clientWidth));
    }
    function build() {
      var n = pageCount();
      if (n === pages) return;
      pages = n;
      dotBox.textContent = '';
      if (n < 2) { dotBox.style.display = 'none'; return; }
      dotBox.style.display = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Page ' + (i + 1));
        b.dataset.page = i;
        b.addEventListener('click', function (e) {
          rail.scrollTo({ left: rail.clientWidth * Number(e.currentTarget.dataset.page), behavior: 'smooth' });
        });
        dotBox.appendChild(b);
      }
      mark();
    }
    function mark() {
      var i = Math.round(rail.scrollLeft / rail.clientWidth);
      dotBox.querySelectorAll('button').forEach(function (b, k) {
        b.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }
    rail.addEventListener('scroll', function () {
      clearTimeout(rail._t);
      rail._t = setTimeout(mark, 80);
    });
    window.addEventListener('resize', build);
    build();
    if ('ResizeObserver' in window) new ResizeObserver(build).observe(rail);
  });

  /* ---- mobile navigation drawer ---- */
  (function () {
    var drawer = document.querySelector('[data-hor-drawer]');
    if (!drawer) return;
    var panel = drawer.querySelector('.hor-drawer__panel');
    function open() {
      drawer.classList.add('is-open');
      document.body.classList.add('hor-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('hor-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      var b = document.querySelector('[data-hor-drawer-open]');
      if (b) b.focus();
    }
    document.querySelectorAll('[data-hor-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-hor-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer.querySelector('.hor-drawer__scrim')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 768) close(); });
  })();

  /* ---- footer accordions (mobile) ---- */
  document.querySelectorAll('.hor-footer__col h3').forEach(function (h) {
    h.addEventListener('click', function () {
      if (window.matchMedia('(max-width:768px)').matches) h.parentElement.classList.toggle('is-open');
    });
  });

  /* ---- specification accordions ---- */
  document.querySelectorAll('.hor-acc__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var acc = head.closest('.hor-acc');
      var open = acc.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      var mark = head.querySelector('i');
      if (mark) mark.textContent = open ? '\u2212' : '+';
    });
  });

  /* ---- product gallery ---- */
  document.querySelectorAll('[data-hor-gallery]').forEach(function (gallery) {
    var stage = gallery.querySelector('[data-hor-stage]');
    gallery.querySelectorAll('.hor-pdp__thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
        if (stage) stage.src = src;
        gallery.querySelectorAll('.hor-pdp__thumb').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---- single-select option groups (metal, ring size) ---- */
  document.querySelectorAll('[data-hor-optgroup]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-hor-opt]');
      if (!btn) return;
      group.querySelectorAll('[data-hor-opt]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
      btn.setAttribute('aria-current', 'true');
      var input = group.querySelector('input[type=hidden]');
      if (input && btn.dataset.value) input.value = btn.dataset.value;
      var label = document.querySelector(group.dataset.horOptgroup);
      if (label && btn.dataset.label) label.textContent = btn.dataset.label;
    });
  });

  /* ---- sticky add-to-cart bar ---- */
  var bar = document.querySelector('[data-hor-stickybar]');
  var anchor = document.querySelector('[data-hor-sticky-anchor]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---- collection filters (mobile) ---- */
  document.querySelectorAll('[data-hor-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.querySelector(btn.getAttribute('data-hor-filter-toggle'));
      if (panel) panel.classList.toggle('is-open');
    });
  });

  /* ---- testimonial dots ---- */
  document.querySelectorAll('[data-hor-testi]').forEach(function (root) {
    var rail = root.querySelector('.hor-testi__grid');
    var dots = root.querySelectorAll('.hor-testi__dots button');
    dots.forEach(function (dot, k) {
      dot.addEventListener('click', function () {
        var card = rail.children[k];
        if (card) rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
        dots.forEach(function (d, j) { d.setAttribute('aria-current', j === k ? 'true' : 'false'); });
      });
    });
    if (dots[0]) dots[0].setAttribute('aria-current', 'true');
  });
});
